import type {Theme, Components} from "@mui/material/styles";

type ListItemButtonOverrides = Components<Theme>["MuiListItemButton"];

const overrides: ListItemButtonOverrides = {
    styleOverrides: {
        root: ({theme}) => ({
            borderRadius: theme.borderRadius.default,

            // Aligns the focus ring created in ButtonBase to the ListItemButton
            "&::before": {
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
            },
        }),
    },
};

export default overrides;
